module.exports = __webpack_public_path__ + "img/2F.e711e758.png";